import { render, staticRenderFns } from "./TourOverviewDialog.vue?vue&type=template&id=2479726e&scoped=true"
import script from "./TourOverviewDialog.vue?vue&type=script&lang=js"
export * from "./TourOverviewDialog.vue?vue&type=script&lang=js"
import style0 from "./TourOverviewDialog.vue?vue&type=style&index=0&id=2479726e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2479726e",
  null
  
)

export default component.exports